import { CheckIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Actions as COMPANYACTIONS } from "../../store/actions/companyActions";
import { Actions as PAYMENTACTIONS } from "../../store/actions/paymentActions";
import _ from "lodash";
import {format} from "date-fns";

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

const BundleCard = ({
	bundle,
	org,
	updateCompanyDetails,
	updateSetting,
	forModal,
	currency,
	status,
	isAdvisor,
	complimentaryUntil,
	complimentary,
	bundleDisabled,
	jurisdiction,
}) => {
	const save = () => {
		updateSetting?.("plan", bundle.id);
		updateCompanyDetails({
			org: String(org),
			plan: bundle.id,
			status: status === "Archived" ? "Active" : status,
		});
	};

	const features = bundle?.jurisdictionFeatures?.[jurisdiction] ?? bundle?.features;

	return (
		<div
			key={bundle.id}
			className={classNames(
				bundle.current ? "bg-white ring-2 ring-orange-700 shadow-md" : "bg-orange-700",
				"pt-6 px-6 pb-3 rounded-lg lg:px-8 lg:pt-12",
			)}
		>
			<div>
				<h3 className={classNames(bundle.current ? "text-orange-600" : "text-white", "font-semibold")}>
					{bundle.name}
				</h3>
				<div className="flex flex-col items-start sm:flex-row sm:items-center sm:justify-between lg:flex-col lg:items-start">
					<div className="mt-3 flex items-center">

							<p
								className={classNames(
									bundle.current ? "text-orange-600" : "text-white",
									(isAdvisor && bundle.hasOwnProperty('bureauPrice')) || complimentary ? "diagonal-strikethrough opacity-50" : "",
									"text-4xl font-bold tracking-tight",
								)}
							>
								{ bundleDisabled ? "N/A" :
									`${currency}${bundle.price}`
								}
							</p>

						{(isAdvisor && bundle.hasOwnProperty('bureauPrice')) &&
							<p
								className={classNames(
									bundle.current ? "text-orange-600" : "text-white",
									complimentary ? "diagonal-strikethrough opacity-75" : "",
									"text-4xl font-bold tracking-tight ml-3",
								)}
							>
								{currency}
								{bundle.bureauPrice}
							</p>
						}
						{!bundleDisabled &&
							<div className="ml-4">
								<p className={classNames(bundle.current ? "text-gray-700" : "text-white", "text-md")}>
									/ Active Employee / Month
								</p>
								{/*
							  <p className={classNames(bundle.current ? 'text-gray-500' : 'text-orange-200', 'text-md')}>
								Billed yearly ({currencySign}{bundle.priceYearly})
							  </p>
							*/}
							</div>
						}
					</div>
					{
						complimentaryUntil && (
							<p className={classNames(bundle.current ? "text-orange-600" : "text-white", "mt-1 text-md")}>
								Complimentary until {format(new Date(complimentaryUntil), "do MMM yyyy")}
							</p>
						)
					}
					<a
						href="#"
						className={classNames(
							bundle.current ? "bg-orange-600 text-white" : "bg-white text-orange-600 hover:bg-orange-50",
							"mt-6 w-full inline-block py-2 px-8 border border-transparent rounded-md shadow-sm text-center text-md font-medium sm:mt-0 sm:w-auto lg:mt-6 lg:w-full",
							bundleDisabled ? "cursor-not-allowed opacity-50" : ""
						)}
						onClick={() => {
							if (bundle.current || bundleDisabled) return;
							save();
						}}
					>
						{bundleDisabled ? "Not Available" : bundle.current ? "Current" : `${forModal ? "Select" : "Switch to"} ${bundle.name}`}
					</a>
				</div>
			</div>
			<h4 className="sr-only">Features</h4>
			<ul
				role="list"
				className={classNames(
					bundle.current
						? "border-gray-200 divide-gray-200"
						: "border-orange-500 divide-orange-500 divide-opacity-75",
					"mt-7 border-t divide-y lg:border-t-0",
				)}
			>
				{features.map((mainFeature, index) => (
					<li
						key={`${bundle.id}_feature_${index}`}
						className="flex items-center py-3"
					>
						<CheckIcon
							className={classNames(
								bundle.current ? "text-orange-500" : "text-orange-200",
								"w-5 h-5 flex-shrink-0",
							)}
							aria-hidden="true"
						/>
						<span
							className={classNames(
								bundle.current ? "text-gray-600" : "text-white",
								"ml-3 text-md font-medium",
							)}
						>
							{mainFeature}
						</span>
					</li>
				))}
			</ul>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const jurisdictions = {
		new: state.company?.newCompany?.jurisdiction,
		current: state.company?.settings?.jurisdiction,
	};

	const currency = state.jurisdictions?.find(
		(j) => j.countryCode === jurisdictions[ownProps.forModal ? "new" : "current"],
	)?.currency;

	const complimentaryUntil = state.company?.settings?.advisor?.complimentaryUntil || state.advisors?.settings?.complimentaryUntil || state.advisors?.settings?.trialExpires;
	let freeUntil =  complimentaryUntil >= format(new Date(), "yyyy-MM-dd") ? complimentaryUntil : false;

	const bundle = ownProps.bundle;

	const jurisdiction = state.company?.settings?.jurisdiction

	const advisorUnlimited = state.my?.profile?.advisorUnlimited


	const bundleDisabled =  (bundle.availableOnly && !Object.keys(bundle.availableOnly[jurisdiction]).every(key => {
        switch (key) {
            case 'advisorUnlimited':
                return advisorUnlimited
            default:
                return true;
        }
      }))

	return {
		org: ownProps.forModal ? state.company?.newCompany?.org : state.company?.settings?.org,
		status: ownProps.forModal ? state.company?.newCompany?.status : state.company?.settings?.status,
		currency,
		bundleDisabled,
		jurisdiction,
		isAdvisor: state.my?.profile?.isAdvisor && state.my?.profile?.advisorUnlimited && state.company?.settings?.advisor,
		complimentaryUntil: freeUntil,
		complimentary: state.company?.settings?.complimentary || state.company?.advisors?.complimentary || !!complimentaryUntil,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	const bundle = ownProps.bundle;

	return {
		updateSetting: (key, value) => dispatch(COMPANYACTIONS.updateSetting(key, value)),
		selectBundle: () => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
		updateCompanyDetails: (body) => dispatch(COMPANYACTIONS.updateCompanyDetails(body, true, ownProps.forModal)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BundleCard);
